// extracted by mini-css-extract-plugin
export default {"card":"leoni-module__card--aUegb","bubbleContainer":"leoni-module__bubbleContainer--T4AZK","badge":"leoni-module__badge--kuJMz"};